import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useLoginReport } from './hooks';
import { LoginReportPresentation } from './presentations';

export const LoginReport: React.FC = () => {
  const {
    state: { rows, currentPage, totalPage, totalCount, isLoading },
    actions: { handlePageChange, handleSort, handleOutputCsv },
  } = useLoginReport();

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows,
    onPageChange: handlePageChange,
  });

  return (
    <LoginReportPresentation
      rows={rows}
      pagerProps={pagerProps}
      isLoading={isLoading}
      onSort={handleSort}
      onOutputCsv={handleOutputCsv}
    />
  );
};
